import React from 'react';
import { useTranslation } from 'react-utilities';
import { NAPageItemConfigType } from '../ConfigTypes';
import { appealsProcessUrl } from '../../utils/constants';
import makeTranslateWithLink from '../../utils/makeTranslateWithLink';
import { EventTypes } from '../../services/eventConstants';

/**
 * Content and page link for the appeals process. Shown based on showAppealsProcessLink
 */
const AppealsProcessPageItem = (): JSX.Element => {
  const { translate } = useTranslation();
  const translateWithLink = makeTranslateWithLink(translate);

  return (
    <div data-testid='appeals-process'>
      {translateWithLink(
        'Description.AppealsProcess',
        appealsProcessUrl,
        undefined,
        EventTypes.AppealsProcessClicked
      )}
    </div>
  );
};

const AppealsProcessPageItemConfig: NAPageItemConfigType = {
  getIsVisible: punishmentData => {
    return punishmentData.showAppealsProcessLink;
  },
  renderComponent: AppealsProcessPageItem,
  configName: 'appeals-process'
};

export default AppealsProcessPageItemConfig;
